import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@standalone/components/icon/icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [RouterLink, IconComponent, RouterLinkActive, TranslocoPipe],
})
export class SidebarComponent {
  public logoUrl: string = 'assets/images/logo.png';
}
